import { ReduxAction } from '../actions';
import { IdentitySessionState } from './types';
import {
  SHOW_FACE_CHECK_MODAL,
  HIDE_FACE_CHECK_MODAL,
  IDENTITY_SESSION_SET_LOADING,
  IDENTITY_SESSION_ERROR,
} from './actions';

export const INITIAL_STATE: IdentitySessionState = {
  showFaceCheckModal: false,
  loading: false,
  error: null,
};

export const IdentitySession = (
  state: IdentitySessionState = INITIAL_STATE,
  action: ReduxAction
): IdentitySessionState => {
  switch (action.type) {
    case SHOW_FACE_CHECK_MODAL: {
      return {
        ...state,
        showFaceCheckModal: true,
      };
    }
    case HIDE_FACE_CHECK_MODAL: {
      return {
        ...state,
        showFaceCheckModal: false,
      };
    }
    case IDENTITY_SESSION_SET_LOADING: {
      const { loading } = action;
      return {
        ...state,
        loading,
      };
    }
    case IDENTITY_SESSION_ERROR: {
      const { message } = action;
      return {
        ...state,
        error: message,
      };
    }
    default: {
      return state;
    }
  }
};
